import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import { Row, InitialAvatarIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { OrderDetailsSheet } from '..';

import { IOrderItem } from '@/modules/wealth/services/portfolio-orders';

interface Props {
  isLoading?: boolean;
  openedOrders: IOrderItem[];
  isScrolling?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenedOrders',
  props: {
    isLoading: { type: Boolean, default: false },
    openedOrders: null,
    isScrolling: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean, openedOrders: IOrderItem[], isScrolling: boolean };

const route = useRoute();



const isOrderDetailsOpen = ref(false);
const selectedOrder = ref<IOrderItem | null>(null);

const orders = computed(() => {
  return props.openedOrders;
});

const openOrderDetails = (order: IOrderItem) => {
  selectedOrder.value = order;
  isOrderDetailsOpen.value = true;
};

function orderSearcher() {
  if (!orders.value) {
    return () => null;
  }

  const allItemsWithOrders = orders.value.flatMap(order => {
    const products = order.details?.products || [];
    return products
      .flatMap(productGroup => productGroup.items || [])
      .map(item => ({ item, order }));
  });

  return function findOrderByProductIdOptimized(orderId: string) {
    const foundEntry = allItemsWithOrders.find(
      entry => entry.item.orderId === orderId
    );
    return foundEntry ? foundEntry.order : null;
  };
}

onMounted(() => {
  const orderId = route.query.orderId as string;

  if (orderId) {
    const searcher = orderSearcher();
    const order = searcher(orderId);

    if (order) {
      selectedOrder.value = order;
      isOrderDetailsOpen.value = true;
    }
  }
});

return { __sfc: true,route, props, isOrderDetailsOpen, selectedOrder, orders, openOrderDetails, orderSearcher, Row, InitialAvatarIcon, BaseText, Money, OrderDetailsSheet }
}

})